import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { ShowWarningNotification, TypedChanges } from '@platform-frontend/util';
import { MatomoTracker } from 'ngx-matomo-client';
import { asapScheduler } from 'rxjs';
import { MARKETPLACE_TRANSLOCO_SCOPE } from '../../marketplace-transloco-scope';
import { MSG_NOTICE_PERIOD_BEFORE_NEXT_RENEWAL } from '../../notification-messages';

@Component({
  selector: 'yat-subscription-cancel',
  templateUrl: './subscription-cancel.component.html',
  styleUrls: ['./subscription-cancel.component.scss'],
  providers: [provideTranslocoScope(MARKETPLACE_TRANSLOCO_SCOPE)]
})
export class SubscriptionCancelComponent implements OnChanges {
  constructor(private readonly matomoTracker: MatomoTracker, private readonly store: Store) {}

  @Output()
  cancelSubscriptionMethod: EventEmitter<void> = new EventEmitter();

  @Output()
  backMethod: EventEmitter<void> = new EventEmitter();

  @Input()
  buttonBackName: 'back' | 'close' = 'back';

  @Input()
  buttonsClassName: string = '';

  @Input()
  endOfPeriod: Date | null = null;

  @Input()
  terminationDate: Date | null = null;

  @Input()
  endOfNoticePeriod: Date | null = null;

  @Input()
  productName?: string;

  @Input()
  liveLicense: boolean = true;

  readonly MATOMO_EVENT_CATEGORY_PURCHASE = 'PURCHASE';

  notificationDispatched: boolean = false;

  ngOnChanges(changes: TypedChanges<SubscriptionCancelComponent>): void {
    if (
      (changes.endOfPeriod || changes.terminationDate) &&
      this.endOfPeriod !== null &&
      this.terminationDate !== null &&
      this.terminationDate > this.endOfPeriod &&
      this.notificationDispatched === false
    ) {
      this.notificationDispatched = true;
      const endOfPeriod: Date = this.endOfPeriod;
      asapScheduler.schedule(() => this.store.dispatch(new ShowWarningNotification(MSG_NOTICE_PERIOD_BEFORE_NEXT_RENEWAL(endOfPeriod))));
    }
  }

  cancelSubscription(): void {
    this.cancelSubscriptionMethod.emit();
    this.matomoTracker.trackEvent(this.MATOMO_EVENT_CATEGORY_PURCHASE, this.liveLicense ? 'Select_CancelSubscription' : 'Select_DemoReset');
  }

  back(): void {
    this.backMethod.emit();
    this.matomoTracker.trackEvent(this.MATOMO_EVENT_CATEGORY_PURCHASE, 'Cancel_CancelSubscription');
  }
}
